import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {closeIcon, moreInformation} from '~/constants/InlineSvgs';
import {isEditDesignInCartMode} from '~/utils/url';

import './index.scss';

const propTypes = {
  designName: PropTypes.string,
  isCurrentDesignInCart: PropTypes.bool,
  showDesignNote: PropTypes.bool
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class DesignNote extends Component {
  static propTypes = propTypes;
  static defaultProps = {
    showDesignNote: true,
    onToggleNote: () => {}
  };

  state = {
    visible: true
  };

  componentDidMount() {
    this.setState({visible: this.props.showDesignNote});
  }

  handleOnClick = () => {
    this.toggleVisible();
  };

  toggleVisible = () => {
    this.setState(previousState => {
      return {
        visible: !previousState.visible
      };
    });
  };

  renderClickIcon() {
    const {visible} = this.state;
    const interactionIcon = visible ? closeIcon : moreInformation;
    const iconClasses = classnames('ndx-DesignNote-icon', {
      'ndx-DesignNote-icon--close': visible
    });

    return (
      <div className={iconClasses} onClick={this.handleOnClick}>
        <span dangerouslySetInnerHTML={renderInlineSvg(interactionIcon)} />
      </div>
    );
  }

  noteText = () => {
    if (isEditDesignInCartMode()) {
      return (
        <div>
          Go ahead and update your design just how you like it. Once you've
          finished designing, simply click
          <b style={{fontWeight: 'bold'}}> Next.</b>
        </div>
      );
    } else {
      return (
        <div>
          Go ahead and start designing your next product. Once you've finished
          designing, simply add it to your cart.
        </div>
      );
    }
  };

  render() {
    const {visible} = this.state;
    const noteClasses = classnames('ndx-DesignNote-noteWrapper', {
      'is-expanded': visible
    });

    return (
      <div className="ndx-DesignNote is-expanded ndx-ProductNote--extended">
        <div className={noteClasses}>
          <div className="ndx-DesignNote-noteWrapper-note">
            <span className="ndx-DesignNote-noteWrapper-noteHeader">
              {isEditDesignInCartMode() ? 'Edit design: ' : 'Start from '}
              <span className="ndx-DesignNote-noteWrapper-noteHeader-designName">
                {this.props.designName}
              </span>
            </span>
            <div className="ndx-DesignNote-noteWrapper-noteText">
              {this.noteText()}
            </div>
          </div>
          {this.renderClickIcon()}
        </div>
      </div>
    );
  }
}

export default DesignNote;
